export default "__VITE_ASSET__j5VAPZMa__"